/** Files never go through the API: browser → storage (directUpload), then the API gets the key. */
import { t as tt } from '../../../../shared/i18n';
import { directUpload, site as siteApi } from '../api';
import { reportStorageError } from '../Media';
import { toastErr } from '../common';

/** Images pasted, dropped or chosen in the editor → media rows. */
export const uploadImages = async (siteId, files) => {
    const api = siteApi(siteId);
    const out = [];
    try {
        for (const f of files) {
            const { key } = await directUpload(api, f, 'media'); // eslint-disable-line no-await-in-loop
            out.push(await api.post('/media/complete', { key })); // eslint-disable-line no-await-in-loop
        }
    } catch (e) {
        if (!reportStorageError(e)) toastErr(e, tt('Upload failed'));
        throw e;
    }
    return out;
};
